import { composeIO } from 'react-compose-io'
import { DetalheControleComissaoPedidoView } from './DetalheControleComissaoPedido.View'
import { detalheControleComissaoPedidoIO } from './DetalheControleComissaoPedidoIO'

export const DetalheControleComissaoPedido = composeIO(DetalheControleComissaoPedidoView, detalheControleComissaoPedidoIO)
